// Generated by purs version 0.15.0
import * as $foreign from "./foreign.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as Specular_Dom_Builder_Class from "../Specular.Dom.Builder.Class/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_WeakDynamic from "../Specular.FRP.WeakDynamic/index.js";
var TextInput = function (x) {
    return x;
};
var Checkbox = /* #__PURE__ */ (function () {
    function Checkbox() {

    };
    Checkbox.value = new Checkbox();
    return Checkbox;
})();
var Radio = /* #__PURE__ */ (function () {
    function Radio() {

    };
    Radio.value = new Radio();
    return Radio;
})();
var unsafeEventKey = function (event) {
    return Control_Applicative.pure(Effect.applicativeEffect)(event.key);
};
var textareaOnChange = function (dictMonadWidget) {
    return function (initial) {
        return function (attrs) {
            return Control_Bind.bind((((dictMonadWidget.MonadReplace2()).MonadCleanup1()).Monad0()).Bind1())(Specular_Dom_Builder_Class["elDynAttr$prime"](dictMonadWidget.MonadDomBuilder0())("textarea")(Control_Applicative.pure(Specular_FRP_WeakDynamic.applicativeWeakDynamic)(attrs))(Specular_Dom_Builder_Class.text(dictMonadWidget.MonadDomBuilder0())(initial)))(function (v) {
                return Control_Bind.bind((((dictMonadWidget.MonadReplace2()).MonadCleanup1()).Monad0()).Bind1())(Specular_Dom_Builder_Class.domEventWithSample(Specular_FRP_Base.monadFRP((dictMonadWidget.MonadFRP1()).MonadEffect0())((dictMonadWidget.MonadReplace2()).MonadCleanup1()))(function (v1) {
                    return $foreign.getTextInputValue(v.value0);
                })("change")(v.value0))(function (changed) {
                    return Specular_FRP_Base.holdDyn(Specular_FRP_Base.monadFRP((dictMonadWidget.MonadFRP1()).MonadEffect0())((dictMonadWidget.MonadReplace2()).MonadCleanup1()))(initial)(changed);
                });
            });
        };
    };
};
var textInputValueOnChange = function (dictMonadFRP) {
    return function (v) {
        return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Effect_Class.liftEffect(dictMonadFRP.MonadEffect0())($foreign.getTextInputValue(v.element)))(function (initial) {
            return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_Dom_Builder_Class.domEventWithSample(dictMonadFRP)(function (v1) {
                return $foreign.getTextInputValue(v.element);
            })("change")(v.element))(function (changed) {
                return Specular_FRP_Base.holdDyn(dictMonadFRP)(initial)(Specular_FRP_Base.leftmost([ v.setValue, changed ]));
            });
        });
    };
};
var textInputValueEventOnEnter = function (dictMonadFRP) {
    return function (v) {
        return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_Dom_Builder_Class.domEventWithSample(dictMonadFRP)(unsafeEventKey)("keypress")(v.element))(function (keypress) {
            var enter = Data_Functor["void"](Specular_FRP_Base.functorEvent)(Specular_FRP_Base.filterEvent(function (v1) {
                return v1 === "Enter";
            })(keypress));
            return Control_Applicative.pure(((dictMonadFRP.MonadCleanup1()).Monad0()).Applicative0())(Specular_FRP_Base.tagDyn(v.value)(enter));
        });
    };
};
var textInputValue = function (v) {
    return v.value;
};
var textInput = function (dictMonadWidget) {
    return function (config) {
        return Control_Bind.bind((((dictMonadWidget.MonadReplace2()).MonadCleanup1()).Monad0()).Bind1())(Specular_Dom_Builder_Class["elDynAttr$prime"](dictMonadWidget.MonadDomBuilder0())("input")(config.attributes)(Control_Applicative.pure((((dictMonadWidget.MonadReplace2()).MonadCleanup1()).Monad0()).Applicative0())(Data_Unit.unit)))(function (v) {
            return Control_Bind.discard(Control_Bind.discardUnit)((((dictMonadWidget.MonadReplace2()).MonadCleanup1()).Monad0()).Bind1())(Effect_Class.liftEffect((dictMonadWidget.MonadFRP1()).MonadEffect0())($foreign.setTextInputValue(v.value0)(config.initialValue)))(function () {
                return Control_Bind.discard(Control_Bind.discardUnit)((((dictMonadWidget.MonadReplace2()).MonadCleanup1()).Monad0()).Bind1())(Specular_FRP_Base.subscribeEvent_((dictMonadWidget.MonadFRP1()).MonadEffect0())((dictMonadWidget.MonadReplace2()).MonadCleanup1())($foreign.setTextInputValue(v.value0))(config.setValue))(function () {
                    return Control_Bind.bind((((dictMonadWidget.MonadReplace2()).MonadCleanup1()).Monad0()).Bind1())(Specular_Dom_Builder_Class.domEventWithSample(Specular_FRP_Base.monadFRP((dictMonadWidget.MonadFRP1()).MonadEffect0())((dictMonadWidget.MonadReplace2()).MonadCleanup1()))(function (v1) {
                        return $foreign.getTextInputValue(v.value0);
                    })("input")(v.value0))(function (domChanged) {
                        return Control_Bind.bind((((dictMonadWidget.MonadReplace2()).MonadCleanup1()).Monad0()).Bind1())(Specular_FRP_Base.holdDyn(Specular_FRP_Base.monadFRP((dictMonadWidget.MonadFRP1()).MonadEffect0())((dictMonadWidget.MonadReplace2()).MonadCleanup1()))(config.initialValue)(Specular_FRP_Base.leftmost([ domChanged, config.setValue ])))(function (value) {
                            return Control_Applicative.pure((((dictMonadWidget.MonadReplace2()).MonadCleanup1()).Monad0()).Applicative0())({
                                element: v.value0,
                                value: value,
                                setValue: config.setValue
                            });
                        });
                    });
                });
            });
        });
    };
};
var textInputOnChange = function (dictMonadWidget) {
    return function (initial) {
        return function (attrs) {
            return Control_Bind.bind((((dictMonadWidget.MonadReplace2()).MonadCleanup1()).Monad0()).Bind1())(textInput(dictMonadWidget)({
                initialValue: initial,
                attributes: Control_Applicative.pure(Specular_FRP_WeakDynamic.applicativeWeakDynamic)(attrs),
                setValue: Specular_FRP_Base.never
            }))(function (input) {
                return textInputValueOnChange(Specular_FRP_Base.monadFRP((dictMonadWidget.MonadFRP1()).MonadEffect0())((dictMonadWidget.MonadReplace2()).MonadCleanup1()))(input);
            });
        };
    };
};
var textInputOnInput = function (dictMonadWidget) {
    return function (initial) {
        return function (attrs) {
            return Data_Functor.map((((((dictMonadWidget.MonadReplace2()).MonadCleanup1()).Monad0()).Bind1()).Apply0()).Functor0())(textInputValue)(textInput(dictMonadWidget)({
                initialValue: initial,
                attributes: Control_Applicative.pure(Specular_FRP_WeakDynamic.applicativeWeakDynamic)(attrs),
                setValue: Specular_FRP_Base.never
            }));
        };
    };
};
var checkbox = function (dictMonadWidget) {
    return function (initial) {
        return function (attrs) {
            var attrs$prime = Data_Semigroup.append(Foreign_Object.semigroupObject(Data_Semigroup.semigroupString))(attrs)(Data_Semigroup.append(Foreign_Object.semigroupObject(Data_Semigroup.semigroupString))(Foreign_Object.singleton("type")("checkbox"))((function () {
                if (initial) {
                    return Foreign_Object.singleton("checked")("checked");
                };
                return Data_Monoid.mempty(Foreign_Object.monoidObject(Data_Semigroup.semigroupString));
            })()));
            return Control_Bind.bind((((dictMonadWidget.MonadReplace2()).MonadCleanup1()).Monad0()).Bind1())(Specular_Dom_Builder_Class["elDynAttr$prime"](dictMonadWidget.MonadDomBuilder0())("input")(Control_Applicative.pure(Specular_FRP_WeakDynamic.applicativeWeakDynamic)(attrs$prime))(Control_Applicative.pure((((dictMonadWidget.MonadReplace2()).MonadCleanup1()).Monad0()).Applicative0())(Data_Unit.unit)))(function (v) {
                return Control_Bind.bind((((dictMonadWidget.MonadReplace2()).MonadCleanup1()).Monad0()).Bind1())(Specular_Dom_Builder_Class.domEventWithSample(Specular_FRP_Base.monadFRP((dictMonadWidget.MonadFRP1()).MonadEffect0())((dictMonadWidget.MonadReplace2()).MonadCleanup1()))(function (v1) {
                    return $foreign.getCheckboxChecked(v.value0);
                })("change")(v.value0))(function (changed) {
                    return Specular_FRP_Base.holdDyn(Specular_FRP_Base.monadFRP((dictMonadWidget.MonadFRP1()).MonadEffect0())((dictMonadWidget.MonadReplace2()).MonadCleanup1()))(initial)(changed);
                });
            });
        };
    };
};
var booleanInputTypeToAttributeValue = function (v) {
    if (v instanceof Checkbox) {
        return "checkbox";
    };
    if (v instanceof Radio) {
        return "radio";
    };
    throw new Error("Failed pattern match at Specular.Dom.Widgets.Input (line 78, column 3 - line 80, column 21): " + [ v.constructor.name ]);
};
var booleanInputView = function (dictMonadWidget) {
    return function (type_) {
        return function (dchecked) {
            return function (dattrs) {
                var dattrs$prime = Data_Functor.map(Specular_FRP_WeakDynamic.functorWeakDynamic)(function (attrs) {
                    return Data_Semigroup.append(Foreign_Object.semigroupObject(Data_Semigroup.semigroupString))(attrs)(Foreign_Object.singleton("type")(booleanInputTypeToAttributeValue(type_)));
                })(dattrs);
                return Control_Bind.bind((((dictMonadWidget.MonadReplace2()).MonadCleanup1()).Monad0()).Bind1())(Specular_Dom_Builder_Class["elDynAttr$prime"](dictMonadWidget.MonadDomBuilder0())("input")(dattrs$prime)(Control_Applicative.pure((((dictMonadWidget.MonadReplace2()).MonadCleanup1()).Monad0()).Applicative0())(Data_Unit.unit)))(function (v) {
                    return Control_Bind.discard(Control_Bind.discardUnit)((((dictMonadWidget.MonadReplace2()).MonadCleanup1()).Monad0()).Bind1())(Specular_FRP_WeakDynamic.subscribeWeakDyn_(Specular_FRP_Base.monadFRP((dictMonadWidget.MonadFRP1()).MonadEffect0())((dictMonadWidget.MonadReplace2()).MonadCleanup1()))($foreign.setCheckboxChecked(v.value0))(dchecked))(function () {
                        return Specular_Dom_Builder_Class.domEventWithSample(Specular_FRP_Base.monadFRP((dictMonadWidget.MonadFRP1()).MonadEffect0())((dictMonadWidget.MonadReplace2()).MonadCleanup1()))(function (v1) {
                            return $foreign.getCheckboxChecked(v.value0);
                        })("change")(v.value0);
                    });
                });
            };
        };
    };
};
var checkboxView = function (dictMonadWidget) {
    return booleanInputView(dictMonadWidget)(Checkbox.value);
};
export {
    getTextInputValue,
    setTextInputValue,
    getCheckboxChecked,
    setCheckboxChecked
} from "./foreign.js";
export {
    textInputOnChange,
    textInputOnInput,
    textareaOnChange,
    textInput,
    textInputValue,
    textInputValueOnChange,
    textInputValueEventOnEnter,
    checkbox,
    checkboxView,
    Checkbox,
    Radio,
    booleanInputView
};
//# sourceMappingURL=index.js.map
